import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import CookieConsent from "./components/CookieConsent";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Presentation from "./pages/Presentation";
import News from "./pages/News";
import Organizations from "./pages/Organizations";
import Dashboard from "./pages/Dashboard";
import NewDecision from "./pages/NewDecision";
import DecisionDetail from "./pages/DecisionDetail";
import Profile from "./pages/Profile";
import AdminDashboard from "./pages/AdminDashboard";
import Objectives from "./pages/Objectives";
import Analytics from "./pages/Analytics";
import AuthCallback from "./pages/AuthCallback";
import SetupOrganization from "./pages/SetupOrganization";
import Alerts from "./pages/Alerts";
import Pricing from "./pages/Pricing";
import SubscriptionSuccess from "./pages/SubscriptionSuccess";
import Legal from "./pages/Legal";
import CGU from "./pages/CGU";
import Privacy from "./pages/Privacy";
import Demo from "./pages/Demo";
import CaseStudies from "./pages/CaseStudies";
import Entreprises from "./pages/Entreprises";
import "./App.css";

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-pulse-soft text-primary text-lg font-medium">Chargement...</div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/vf-actions" element={<Presentation />} />
          <Route path="/actualites" element={<News />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/setup-organization" element={<SetupOrganization />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/mentions-legales" element={<Legal />} />
          <Route path="/cgu" element={<CGU />} />
          <Route path="/confidentialite" element={<Privacy />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/temoignages" element={<CaseStudies />} />
          <Route path="/entreprises" element={<Entreprises />} />
          <Route
            path="/subscription/success"
            element={
              <ProtectedRoute>
                <SubscriptionSuccess />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/decision/new"
            element={
              <ProtectedRoute>
                <NewDecision />
              </ProtectedRoute>
            }
          />
          <Route
            path="/decision/:id"
            element={
              <ProtectedRoute>
                <DecisionDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/objectives"
            element={
              <ProtectedRoute>
                <Objectives />
              </ProtectedRoute>
            }
          />
          <Route
            path="/analytics"
            element={
              <ProtectedRoute>
                <Analytics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/alerts"
            element={
              <ProtectedRoute>
                <Alerts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/organizations"
            element={
              <ProtectedRoute>
                <Organizations />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute adminOnly>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
        <Toaster position="top-right" richColors />
        <CookieConsent />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
